import { Button, Input, Modal } from '../../../components';
import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { Divider } from 'antd';
import { deleteCommaSeparator, faNumToEnNum } from '../../../../scripts';
import { requestReferralWithdrawal } from './referralWithdrawalModal.service';

interface Props {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    balance?: number;
    onComplete: () => void;
}

export const ReferralWithdrawalModal: FC<Props> = (props) => {
    const [amount, setAmount] = useState<number>();
    const [loading, setLoading] = useState<boolean>(false);

    const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = deleteCommaSeparator(faNumToEnNum(e.target.value));
        const numericValue = Number(inputValue);

        if (inputValue === '' || isNaN(numericValue)) {
            setAmount(undefined);
        } else {
            setAmount(numericValue);
        }
    };

    const handleSubmit = () => {
        const onComplete = () => {
            props.setOpen(false);
            props.onComplete();
        }

        requestReferralWithdrawal(setLoading, { amount }, onComplete)
    }

    useEffect(() => {
        !props.open && setAmount(undefined)
    }, [props.open])

    return (
        <Modal open={props.open} setOpen={props.setOpen} title={"برداشت موجودی فعلی"}>
            <Divider />
            <Input
                placeholder={'مبلغ برداشتی را وارد نمایید...'}
                inputMode={'numeric'}
                label={"مبلغ برداشتی:"}
                type={'text'}
                value={amount?.toLocaleString()}
                onChange={handleAmountChange}
                dir={amount ? 'ltr' : 'rtl'}
            />
            <div className={'flex justify-between mt-4 items-center'}>
                <div className={'flex items-center gap-2'}>
                    <div className={'rounded-full bg-primary-100 w-2 h-2'} />
                    <p className={'font-bold text-base max-lg:text-xs'}>موجودی فعلی:</p>
                    <span className={'font-bold text-base max-lg:text-sm'}>{props.balance?.toLocaleString()}</span>
                    <span className={'font-medium text-base max-lg:text-xs'}>تومان</span>
                </div>
                <div className={'font-bold text-base clickable text-primary-100 max-lg:text-xs'} onClick={() => setAmount(props.balance)}>انتخاب کل موجودی</div>
            </div>
            <Button className={"mt-6 w-full"} type={"primary"} onClick={handleSubmit} loading={loading} disabled={loading || !amount}>برداشت</Button>
        </Modal>
    )
}